module.exports = __webpack_public_path__ + "static_portal/img/bg-video_moment_21.70c89447.jpg";